import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const LandingPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-4">
            CertifyMyHealth
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Medical Certificate Management System
          </p>

          <div className="flex gap-4 justify-center">
            <Link
              to="/login"
              className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-lg font-semibold"
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="px-8 py-3 bg-white text-blue-600 border-2 border-blue-600 rounded-lg hover:bg-blue-50 transition-colors text-lg font-semibold"
            >
              Sign Up
            </Link>
          </div>

          {process.env.NODE_ENV === 'development' && (
            <div className="mt-8">
              <Link
                to="/auth-test"
                className="text-sm text-gray-500 hover:text-gray-700 underline"
              >
                🧪 Auth Test Page (Dev Only)
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};